import { findDOMNode as defaultFindDOMNode } from 'react-dom';
import smoothscroll from 'smoothscroll-polyfill';

const scrollToTop = (component, findDOMNode = defaultFindDOMNode) => {
  findDOMNode(component).scrollTop = 0;
};

export const smoothScroll = el => el.scrollIntoView({ behavior: 'smooth', block: 'start' });

export const smoothScrollWithOffset = offset => el => {
  smoothscroll.polyfill();

  const topOfElement = el.offsetTop - offset;
  window.scroll({ top: topOfElement, behavior: "smooth" });
};

export default scrollToTop;
